import React from "react";
import { Button } from "../../../components/ui/button";
import { Link } from "react-router-dom";

const TrialistPrivacyPolicy = () => {
  return (
    <div className='min-h-screen bg-black text-white p-8'>
      <div className='max-w-3xl mx-auto'>
        <h1 className='text-4xl font-bold mb-8'>Trialist Privacy Policy</h1>

        <div className='space-y-6'>
          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              1. Information We Collect
            </h2>
            <p className='text-gray-300'>
              Trialist collects information necessary for research study
              participation, including account information, study responses,
              health data you choose to share, and app usage data. We only
              collect data that is essential for research purposes.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              2. How We Use Your Information
            </h2>
            <p className='text-gray-300'>
              Your information is used to facilitate your participation in
              research studies, analyze study data, improve research outcomes,
              and communicate with you about study activities. Research data may
              be used in aggregate, de-identified form for scientific
              publications.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              3. Research Data Protection
            </h2>
            <p className='text-gray-300'>
              We implement strict data protection measures in compliance with
              research ethics standards. Your personal information is kept
              confidential and separate from research data. We use encryption
              and secure storage to protect your information.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              4. Your Rights
            </h2>
            <p className='text-gray-300'>
              You have the right to access, correct, or delete your personal
              information. You may withdraw from any study at any time without
              penalty. Upon withdrawal, we will stop collecting new data, though
              previously collected de-identified data may remain in research
              datasets.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>5. Contact Us</h2>
            <p className='text-gray-300'>
              If you have any questions about our Privacy Policy or your data,
              please contact us at: privacy@anyonelabs.com
            </p>
          </section>
        </div>

        <div className='mt-8'>
          <Link to='/'>
            <Button variant='outline' className='text-green-500 border-green-500'>
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TrialistPrivacyPolicy;
